import { render, staticRenderFns } from "./PurchaseOrders.vue?vue&type=template&id=dfc4d2bc&scoped=true&"
import script from "./PurchaseOrders.vue?vue&type=script&lang=ts&"
export * from "./PurchaseOrders.vue?vue&type=script&lang=ts&"
import style0 from "./PurchaseOrders.vue?vue&type=style&index=0&id=dfc4d2bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfc4d2bc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VDatePicker,VMenu,VProgressLinear,VSelect,VTextField})
